module.exports = __webpack_public_path__ + "static/media/factory_robot_arm.06f6f8fd.bin";